import { defineComponent as _defineComponent } from 'vue'
import * as validation from 'JS/components/blain-form/validation';
import BForm from 'JS/components/blain-form/BForm.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import { BSubmitButton, BTextField } from "Src/js/components/blain-form";
import { onMounted, ref } from 'vue';
import { FormatOptions } from 'JS/components/blain-form/formatting';
import { IJoinRewardsStep, ILinkRewardsUser, ILinkRewardsUserResponse, RewardsReasonCode } from 'JS/types/rewards';
import { useServices } from '../../composables/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'EnterVerificationCode',
  props: {
    redactedString: null,
    userPhone: null,
    userEmail: null
  },
  emits: ["close", "switch-page", "loading"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'close'): void,
	(e: 'switch-page', page: IJoinRewardsStep): void,
	(e: 'loading', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	redactedString?: string,
	userPhone?: string,
	userEmail?: string,
}





const { rewardsService } = useServices();

const userInput = ref<string>("");
const errorMessage = ref<string>("");
const headerFocuser = ref<HTMLElement | null>(null);

const verificationCodeFormat: FormatOptions = {
	type: 'numeric',
	length: 6
};

const rewardsNumberFormat: FormatOptions = {
	type: 'numeric',
	length: 13
};

async function handleValidateConfirmationCode() {
	emit('loading', true);

	if (props.redactedString) {
		const result = await rewardsService.confirmUserCode(userInput.value);
		if (!result?.success) {
			if (result.reasonCode === RewardsReasonCode.CUSTOMER_HAS_REWARDS) {
				emit('switch-page', 'customer-has-rewards');
			} else {
				errorMessage.value = result.errorMessage;
			}
		} else {
			window.blainGtmDataLayer.push({
				'event': "connect_rewards"
			});
			emit('switch-page', 'success');
		}
	} else {
		const userRewardsData: ILinkRewardsUser = {
			phoneNumber: props.userPhone,
			email: props.userEmail,
			rewardsNumber: userInput.value,
			verificationMethod: 'rewardsNumber',
		};
		const results: ILinkRewardsUserResponse = await rewardsService.linkUser(userRewardsData);
		if (!results.success) {
			errorMessage.value = "Rewards card number does not match the account you are trying to connect.";
		}  else {
			window.blainGtmDataLayer.push({
				'event': "connect_rewards"
			});
			emit('switch-page', 'success');
		}
	}
	emit('loading', false);
}

onMounted(()=> {
	headerFocuser.value?.focus();
});


return { __sfc: true,props, emit, rewardsService, userInput, errorMessage, headerFocuser, verificationCodeFormat, rewardsNumberFormat, handleValidateConfirmationCode, validation, BForm, LinkButton, BSubmitButton, BTextField }
}

})